module.exports = __webpack_public_path__ + "KN.png?13ddd2f6a75049859d8b55f932e92b63";